import React from 'react'

import './FiltersPlaceholder.scss'

const FiltersPlaceholder = () => {
    return (
        <div className="filters-placeholder-outer">
            <div className="filters-placeholder-inner">
                <div className="placeholder-header">
                    <span></span>
                </div>
                <div className="placeholder-filters">
                    <div className="placeholder-filter">
                        <div className="placeholder-title">
                            <span></span>
                        </div>
                    </div>
                    <div className="placeholder-filter">
                        <div className="placeholder-title">
                            <span></span>
                        </div>
                    </div>
                    <div className="placeholder-filter">
                        <div className="placeholder-title">
                            <span></span>
                        </div>
                    </div>
                    <div className="placeholder-filter">
                        <div className="placeholder-title">
                            <span></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FiltersPlaceholder
